// context/ProductContext.tsx
import React, { createContext, useContext, useReducer } from 'react';

interface Product {
  id: number;
  name: string;
  category: string;
  price: number;
  description: string;
  image: string;
}

interface ProductState {
  products: Product[];
  filteredProducts: Product[];
  categories: string[];
}

type ProductAction = 
  | { type: 'SET_PRODUCTS'; payload: Product[] }
  | { type: 'FILTER_PRODUCTS'; payload: string };

const ProductContext = createContext<{
  state: ProductState;
  dispatch: React.Dispatch<ProductAction>;
} | null>(null);

const productReducer = (state: ProductState, action: ProductAction): ProductState => {
  switch (action.type) {
    case 'SET_PRODUCTS':
      return { ...state, products: action.payload, filteredProducts: action.payload };
    case 'FILTER_PRODUCTS':
      return {
        ...state,
        filteredProducts: action.payload === 'all' 
          ? state.products 
          : state.products.filter(product => product.category === action.payload)
      };
    default:
      return state;
  }
};

export const ProductProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [state, dispatch] = useReducer(productReducer, {
    products: [],
    filteredProducts: [],
    categories: ['Tiles', 'Granite', 'CP Fittings', 'Bath Fittings', 'Sanitary Ware']
  });

  return (
    <ProductContext.Provider value={{ state, dispatch }}>
      {children}
    </ProductContext.Provider>
  );
};

export const useProducts = () => {
  const context = useContext(ProductContext);
  if (!context) {
    throw new Error('useProducts must be used within a ProductProvider');
  }
  return context;
};